import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "@tanstack/react-router";
import { Reveal } from "./Reveal";
import { faqsForService } from "@/lib/service-faqs";

export function ServiceFaqSection({ slug, serviceName }: { slug: string; serviceName: string }) {
  const faqs = faqsForService(slug);
  if (faqs.length === 0) return null;

  return (
    <section id="faq" className="scroll-mt-28 px-6 py-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[340px_1fr]">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-widest text-brand-accent">FAQ</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-navy sm:text-4xl">
              {serviceName} questions, answered
            </h2>
            <p className="mt-4 text-base leading-relaxed text-brand-navy/60">
              Scope, timelines, security, and pricing — the things prospective clients ask before
              handing this function over.
            </p>
            <Link
              to="/contact"
              search={{ service: undefined, industry: undefined }}
              className="mt-6 inline-block rounded-xl border border-brand-navy/15 px-6 py-3 text-sm font-semibold text-brand-navy transition-[border-color,color,background-color,transform] duration-150 ease-out hover:border-brand-accent/50 hover:text-brand-accent active:scale-[0.975] active:duration-75 motion-reduce:transform-none select-none"
            >
              Ask us something else
            </Link>
          </Reveal>

          <Reveal delay={0.08}>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((item, i) => (
                <AccordionItem key={item.q} value={`faq-${i}`}>
                  <AccordionTrigger className="text-left text-base font-semibold text-brand-navy">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-navy/60">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
